import { css } from '@emotion/core';
import styled from '@emotion/styled';
import {
  MAX_WIDTH,
  BREAKPOINT_SMALL,
  DEFAULT_DESKTOP_PADDING,
  DEFAULT_MOBILE_PADDING,
  COLOR_DARK_PURPLE,
  COLOR_PURPLE,
  COLOR_MAROON,
} from '../../components/MarketingPagesShared/styles';

export const SwitchPageGlobalStyles = css`
  html {
    // Overscroll color
    background: ${COLOR_DARK_PURPLE};
  }
  body {
    background: ${COLOR_MAROON};
  }
`;

export const SwitchPage = styled.main``;

export const SwitchPageSection = styled.section`
  max-width: ${MAX_WIDTH}px;
  margin: 0 auto;
  font-size: 1.6rem;
  color: white;
  padding: 0 ${DEFAULT_DESKTOP_PADDING}px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: 0 ${DEFAULT_MOBILE_PADDING}px;
  }
`;

export const ImportSectionBackground = styled.div`
  background: ${COLOR_DARK_PURPLE};
`;

export const SignupSectionBackground = styled.section`
  background: ${COLOR_PURPLE};
  padding-top: 10vh;
`;
